import keyMirror from "keymirror";

export default keyMirror({
  INIT_FAVORITES_PROJECTS: null,
  ADD_PROJECT_TO_FAVORITES: null,
  REMOVE_PROJECT_FROM_FAVORITES: null,
  UPDATE_FAVORITE_PROJECT: null,
});